import { render, staticRenderFns } from "./addActivityGroup.vue?vue&type=template&id=6d598a20"
import script from "./addActivityGroup.vue?vue&type=script&lang=js"
export * from "./addActivityGroup.vue?vue&type=script&lang=js"
import style0 from "./addActivityGroup.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports